// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__ceF8L","footer":"ModalInfo_footer__2QFm0"};